import { useState } from 'react';

/**
 * Modal/menu open-close boolean state cluster extracted from App.tsx.
 * Pure mechanical move — names match the original useState identifiers
 * so call sites in App.tsx are unchanged beyond the destructure.
 */
export const useModalStates = () => {
  const [isWhiteLabelOpen, setIsWhiteLabelOpen] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  // Modal States
  const [isMementoOpen, setIsMementoOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isVeoStudioOpen, setIsVeoStudioOpen] = useState(false);
  const [isAuraStudioOpen, setIsAuraStudioOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [calendarMenuOpen, setCalendarMenuOpen] = useState(false);

  return {
    isWhiteLabelOpen, setIsWhiteLabelOpen,
    showPayment, setShowPayment,
    isUserMenuOpen, setIsUserMenuOpen,
    isMementoOpen, setIsMementoOpen,
    isEmailModalOpen, setIsEmailModalOpen,
    isVeoStudioOpen, setIsVeoStudioOpen,
    isAuraStudioOpen, setIsAuraStudioOpen,
    isShareModalOpen, setIsShareModalOpen,
    calendarMenuOpen, setCalendarMenuOpen,
  };
};
